import { t } from "i18next"

export function getRankLabel(rank: number) {
  switch (rank) {
    case 1:
      return t("rank_labels.first_place")
    case 2:
      return t("rank_labels.second_place")
    case 3:
      return t("rank_labels.third_place")
  }
  // 国服: 原来查顶层 "th_place"(不存在,翻译在 rank_labels 下)导致第4-8名显示成
  // "th_place N"。改为查 rank_labels.th_place 并用插值传入名次。
  return t("rank_labels.th_place", { rank })
}
